import Vue from 'vue'
import Router from 'vue-router'
import { authGuard, noAuthGuard } from './guards/AuthGuard'

import Login from './views/Login.vue'
import RecoverPassword from './views/RecoverPassword.vue'
import RedefinePassword from './views/RedefinePassword.vue'

import Users from './views/Users.vue'
import ChannelAuthorization from './views/ChannelAuthorization.vue'
import Channels from './views/Channels.vue'
import Cms from './views/Cms.vue'
import Dashboard from './views/Dashboard.vue'
import DashboardChannel from './views/DashboardChannel.vue'
import Report from './views/Report.vue'

import ErrorNotFound from './views/ErrorNotFound.vue'
import ErrorInternalServer from './views/ErrorInternalServer.vue'
import ErrorForbidden from './views/ErrorForbidden.vue'
import ErrorBadGateway from './views/ErrorBadGateway.vue'

Vue.use(Router)

const routes = [
    { 
      path: '/login',
      name: 'login',
      beforeEnter: noAuthGuard,
      component: Login,
      meta: {
        title: 'Login - 1BMG'
      }
    },
    { 
      path: '/esqueci-minha-senha',
      name: 'esqueci-minha-senha',
      beforeEnter: noAuthGuard,
      component: RecoverPassword,
      meta: {
        title: 'Esqueci minha senha - 1BMG'
      }
    },
    { 
      path: '/redefinir-senha/:token',
      name: 'redefinir-senha',
      beforeEnter: noAuthGuard,
      component: RedefinePassword,
      meta: {
        title: 'Redefinir senha - 1BMG'
      }
    },
    { 
      path: '/usuarios',
      name: 'manage_users',
      beforeEnter: authGuard,
      component: Users,
      meta: {
        title: 'Gerenciamento de usuários - 1BMG'
      }
    },
    { 
      path: '/autorizacao-canais',
      name: 'authorize_channels',
      beforeEnter: authGuard,
      component: ChannelAuthorization,
      meta: {
        title: 'Autorização de canais - 1BMG'
      }
    },
    { 
      path: '/canais',
      name: 'manage_channels',
      beforeEnter: authGuard,
      component: Channels,
      meta: {
        title: 'Gerenciamento de canais - 1BMG'
      }
    },
    { 
      path: '/cms',
      name: 'manage_channels',
      beforeEnter: authGuard,
      component: Cms,
      meta: {
        title: 'Gerenciamento de CMS - 1BMG'
      }
    },
    { 
      path: '/dashboard',
      name: 'view_global_dashboard',
      beforeEnter: authGuard,
      component: Dashboard,
      meta: {
        title: 'Dashboard - 1BMG'
      }
    },
    { 
      path: '/dashboard-canal',
      name: 'view_channel_dashboard',
      beforeEnter: noAuthGuard,
      component: DashboardChannel,
      meta: {
        title: 'Dashboard de Canal - 1BMG'
      }
    },
    { 
      path: '/report',
      name: 'manage_channels',
      beforeEnter: authGuard,
      component: Report,
      meta: {
        title: 'Relatório - 1BMG'
      }
    },
    {
      path: '/erro/404',
      name: '404',
      component: ErrorNotFound,
      meta: {
        title: 'Página não encontrada - 1BMG'
      }
    },
    {
      path: '/erro/500',
      name: '500',
      component: ErrorInternalServer,
      meta: {
        title: 'Erro interno - 1BMG'
      }
    },
    {
      path: '/erro/403',
      name: '403',
      component: ErrorForbidden,
      meta: {
        title: 'Acesso negado - 1BMG'
      }
    },
    {
      path: '/erro/502',
      name: '502',
      component: ErrorBadGateway,
      meta: {
        title: 'Acesso negado - 1BMG'
      }
    },
    { 
      path: '/',
      redirect: { name: 'view_channel_dashboard', params: { resource: 'page' } }
    },
    {
      path: '*',
      redirect: { name: '404', params: { resource: 'page' } }
    }
]   
const router = new Router({
    mode: 'history',
    routes: routes
})

export default router;